module.exports = __webpack_public_path__ + "img/blokker.b277b6ae.jpeg";